module.exports = __webpack_public_path__ + "media/images/resource-placeholder01-e549c7b6c125160fd1a7de7759fd8e2f.jpg";